import {Reducer} from 'redux';
import {State} from '../model/State';
import {IAction} from '../model/IAction';
import {ISubProcessData} from '../model/IProcessData';

import * as FetchActions from '../actions/FetchDataItems';

export function subProcesses(state: ISubProcessData[] = [], action: IAction): ISubProcessData[] {
     switch (action.type) {
        case FetchActions.RECEIVE_SUB_PROCESSES:
            const receiveAction = action as FetchActions.IReceiveSubProcessesAction;
            return receiveAction.subProcessData;
        default:
            return state;
    }
}

